/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon16Regular = forwardRef('ArrowDCornerUpLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.22 1.97a.75.75 0 0 1 1.06 1.06L4.06 6.25H12A2.75 2.75 0 0 1 14.75 9v6.25a.75.75 0 0 1-1.5 0V9c0-.69-.56-1.25-1.25-1.25H4.06l3.22 3.22a.75.75 0 1 1-1.06 1.06L2.568 8.38a1.95 1.95 0 0 1 0-2.758L6.22 1.97Z" })));
});
